module.exports = __webpack_public_path__ + "static/media/uva_logo.09e51cbf.png";